export { Divider } from './Divider';
export type { Props } from './Divider.types';
